import { Col, Form, Row, Spinner } from "react-bootstrap"

import NotificationMethod from "../../../api/Notifications/Model/NotificationMethod"
import NotificationContactData from "../../../api/Randoms/Notification/NotificationContactData"
import ToggleSwitch from "../../FormattedInputs/ToggleSwitch"

interface NotificationMethodsTabProps {
  loading?: boolean
  methods?: Record<string, NotificationMethod>
  contact?: NotificationContactData
  showTitle?: boolean
  onChange: (code: string, checked: boolean) => void
}

function NotificationMethodsTab({
  loading = false,
  methods = {},
  contact = undefined,
  showTitle = false,
  onChange,
}: NotificationMethodsTabProps) {
  const disableMethod = (code: string) => {
    switch (code.toUpperCase()) {
      case "EMAIL":
        return !contact?.Email
      case "TEXT":
        return !contact?.Phone
      default:
        return false
    }
  }

  const methodText = {
    EMAIL: "Please provide an Email address for this method.",
    TEXT: "Please provide a Phone number for this method.",
  } as Record<string, string>

  return (
    <>
      {showTitle && <h5>How would you like to be notified?</h5>}
      {loading && <Spinner animation="border" variant="secondary" className="mb-1" />}
      {!loading &&
        Object.values(methods || {}).map((method) => (
          <div key={method.Code}>
            <Form.Group as={Row} className="mb-1">
              <Form.Label column sm={1} className="d-flex align-items-center">
                {method.Description}
              </Form.Label>
              <Col sm={2} className="d-flex align-items-center">
                <ToggleSwitch
                  on="Yes"
                  off="No"
                  className="mb-0"
                  disabled={disableMethod(method.Code)}
                  checked={method.selected}
                  onCheck={(checked) => onChange(method.Code, checked)}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="my-0">
              <Col>
                <Form.Text as="span" muted className="small" style={{ position: "relative", top: "-10px" }}>
                  {methodText[method.Code]}
                </Form.Text>
              </Col>
            </Form.Group>
          </div>
        ))}
    </>
  )
}

export default NotificationMethodsTab
